import { axiosInstance } from "../../../axios/axiosInstance";

const GET_USER_CARDS = `payment/cards/all`;
const CREATE_PAYMENT_INTENT = `payment/create-payment-intent`;
const GET_PAYMENT_INTENT = `payment/get-payment-intent`;
const PURCHASE_PLAN = `organization/subscription-plan-history/purchase-plan`;
const VALIDATE_COUPON = `payment/validate_coupon`;
const PURCHASE_PUSH_NOTIFICATION =
  "organization/push-notifications/purchase-notification";
const GET_COUNTRY_TAX_DETAILS = "country-tax/view_by_country_code";

export const getAllCards = () => {
  return axiosInstance.get(`${GET_USER_CARDS}`);
};

export const getTaxDetails = () => {
  return axiosInstance.get(`${GET_COUNTRY_TAX_DETAILS}/AE`);
};

export const createPaymentIntent = (dataToBeSent) => {
  return axiosInstance.post(`${CREATE_PAYMENT_INTENT}`, dataToBeSent);
};

export const getPaymentIntent = (dataToBeSent) => {
  return axiosInstance.get(
    `${GET_PAYMENT_INTENT}/${dataToBeSent?.paymentIntentId}`
  );
};

export const purchasePlan = (dataToBeSent) => {
  return axiosInstance.post(`${PURCHASE_PLAN}`, dataToBeSent);
};

export const purchasePushNotification = (dataToBeSent) => {
  return axiosInstance.post(`${PURCHASE_PUSH_NOTIFICATION}`, dataToBeSent);
};

export const validateCouponCode = (dataToBeSent) => {
  return axiosInstance.post(`${VALIDATE_COUPON}`, dataToBeSent);
};
